import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
  fetchBuildings,
  showUpdateBuildingForm,
  deleteBuilding,
  fetchTokens,
  showTokens,
  changePage,
  showCustomizeForm
} from '../actions/buildings.js'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { Card, CardText } from 'material-ui/Card'
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table'
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import CircularProgress from 'material-ui/CircularProgress'
import Pagination from 'material-ui-pagination'

import ConfirmButton from 'material-ui-confirm-button'

import Delete from 'material-ui/svg-icons/action/delete'
import EditColor from 'material-ui/svg-icons/editor/format-color-fill'
import Edit from 'material-ui/svg-icons/image/edit'
import ActionAssignmentInd from 'material-ui/svg-icons/action/assignment-ind'

import AddBuilding from '../components/buildings/AddBuilding'
import CustomizeBuildings from '../components/buildings/CustomizeBuildings'
import Tokens from '../components/buildings/Tokens'
import GenerateTokens from '../components/buildings/GenerateTokens'

const style = {
  margin: 0
}

const iconStyle = {
  margin: 0,
  padding: 0,
  minWidth: 0,
  width: 50
}

class Buildings extends Component {
  static defaultProps = {
    pageNumber: 1,
    itemsPerPage: 50,
    paginationDisplay: 10
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { dispatch } = this.props
    document.title = 'Buildings - Admin - Better Spaces'
    this.fetchPageBuildings()
  }

  componentDidUpdate() {
    if (this.props.pageChanged) {
      this.fetchPageBuildings()
    }
  }

  fetchPageBuildings() {
    const { dispatch } = this.props
    dispatch(fetchBuildings((this.props.pageNumber - 1) * this.props.itemsPerPage, this.props.itemsPerPage))
  }

  showAddBuildingForm() {
    const { dispatch } = this.props
    dispatch(showUpdateBuildingForm({}))
  }

  updateBuilding(building) {
    const { dispatch } = this.props
    dispatch(showUpdateBuildingForm(building))
  }

  deleteBuilding(building) {
    const { dispatch } = this.props
    dispatch(deleteBuilding(building))
  }

  showTokens(building) {
    const { dispatch } = this.props
    dispatch(showTokens(building))
    dispatch(fetchTokens(building))
  }

  showCustomize(building) {
    const { dispatch } = this.props
    dispatch(showCustomizeForm(building))
  }

  showCustomize(building) {
    const { dispatch } = this.props
    dispatch(showCustomizeForm(building))
  }

  onPageChanged(newPageNumber) {
    const { dispatch } = this.props
    if (newPageNumber != this.props.pageNumber)
      dispatch(changePage(newPageNumber))
  }

  render() {
    if (!this.props.isFetching) {
      if (this.props.buildings) {
        this.props.buildings.sort(function(a, b) {
          if (a.name < b.name) return -1
          if (a.name > b.name) return 1
          return 0
        })

        return (
          <div>
            <AddBuilding />
            <CustomizeBuildings />
            <Tokens />
            <GenerateTokens />
            {this.props.role.length > 3 && this.props.role.charAt(3) == '2' ? (
              <RaisedButton
                label='Add Building'
                primary={true}
                style={style}
                onClick={this.showAddBuildingForm.bind(this)}
              />
            ) : (
              <div />
            )}
            <br /> <br />
            <Pagination
              total={Math.ceil(this.props.buildingsCount / this.props.itemsPerPage)}
              current={this.props.pageNumber}
              display={this.props.paginationDisplay}
              onChange={this.onPageChanged.bind(this)}
            />
            <Table selectable={false} style={{ tableLayout: 'auto' }} fixedHeader={false}>
              <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>
                  <TableHeaderColumn style={{ width: '3%' }}>ID</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '3%' }}>Name</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '3%' }}>City</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '3%' }}>Address</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '3%' }}>State</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '6%' }} />
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false}>
                {this.props.buildings.map((building, index) => (
                  <TableRow>
                    <TableRowColumn style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                      {building.index}
                    </TableRowColumn>
                    <TableRowColumn style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                      {building.name}
                    </TableRowColumn>
                    <TableRowColumn style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                      {building.city}
                    </TableRowColumn>
                    <TableRowColumn style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                      {building.address2 == undefined ? (
                        <div>{building.address1}</div>
                      ) : (
                        <div>{building.address1 + ' ' + building.address2}</div>
                      )}
                    </TableRowColumn>
                    <TableRowColumn style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                      {building.state}
                    </TableRowColumn>
                    {this.props.role.length > 3 && this.props.role.charAt(3) == '2' ? (
                      <TableRowColumn style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                        <FlatButton
                          icon={<Edit />}
                          style={iconStyle}
                          primary={true}
                          onClick={this.updateBuilding.bind(this, building)}
                        />
                        <FlatButton
                          icon={<ActionAssignmentInd />}
                          style={iconStyle}
                          primary={true}
                          onClick={this.showTokens.bind(this, building)}
                        />
                        <ConfirmButton
                          key={building._id}
                          isFlat={true}
                          style={iconStyle}
                          icon={<Delete />}
                          confirmMessage='	&#10004;'
                          cancelMessage='X'
                          secondary={true}
                          onSubmit={this.deleteBuilding.bind(this, building)}
                        />
                        <FlatButton
                          icon={<EditColor />}
                          style={iconStyle}
                          primary={true}
                          onClick={this.showCustomize.bind(this, building)}
                        />
                      </TableRowColumn>
                    ) : (
                      <TableRowColumn />
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Pagination
              total={Math.ceil(this.props.buildingsCount / this.props.itemsPerPage)}
              current={this.props.pageNumber}
              display={this.props.paginationDisplay}
              onChange={this.onPageChanged.bind(this)}
            />
          </div>
        )
      } else {
        return (
          <Card style={{ width: '100%', height: '100%' }}>
            <CardText style={{ position: 'relative', width: '100%', height: '100%' }}>No Buildings</CardText>
          </Card>
        )
      }
    } else {
      return (
        <Card style={{ width: '100%', height: '100%' }}>
          <CardText style={{ position: 'relative', width: '100%', height: '100%' }}>
            <CircularProgress size={80} thickness={5} style={{ marginLeft: '50%' }} />
          </CardText>
        </Card>
      )
    }
  }
}

const mapStateToProps = state => {
  const { isFetching } = state.buildingsReducer

  if (isFetching) {
    return {
      isFetching
    }
  } else {
    return {
      ...state.buildingsReducer,
      role: state.usersReducer.role
    }
  }
}

export default withRouter(connect(mapStateToProps)(Buildings))



// WEBPACK FOOTER //
// ./src/containers/Buildings.js